import {
  EXPANDED_SIDEBAR_WIDTH,
  SIDEBAR_COLLAPSE_BREAKPOINT,
} from "@/app-shell/navigation/sidebarDimensions"

interface GridConfig {
  CONTAINER_PADDING: [number, number]
  MARGIN: [number, number]
  ROW_HEIGHT: number
}

interface ScalingConfig {
  BASE_VIEWPORT_WIDTH: number
  ENABLE_PROPORTIONAL_SCALING: boolean
  MAX_CONTAINER_WIDTH: number
  MIN_CONTAINER_WIDTH: number
}

const COVI_DOCK_WIDTH_CSS_VAR = "--covi-dock-width"
const GRID_WRAPPER_HORIZONTAL_PADDING = 48

export function getScaledGridDimensions(
  gridConfig: GridConfig,
  scalingConfig: ScalingConfig,
  containerWidth?: number,
): {
  rowHeight: number
  margin: [number, number]
  containerPadding: [number, number]
} {
  if (!scalingConfig.ENABLE_PROPORTIONAL_SCALING) {
    return {
      rowHeight: gridConfig.ROW_HEIGHT,
      margin: gridConfig.MARGIN,
      containerPadding: gridConfig.CONTAINER_PADDING,
    }
  }

  const actualWidth = containerWidth || scalingConfig.BASE_VIEWPORT_WIDTH
  const scaleFactor = actualWidth / scalingConfig.BASE_VIEWPORT_WIDTH

  return {
    rowHeight: Math.max(20, gridConfig.ROW_HEIGHT * scaleFactor),
    margin: gridConfig.MARGIN,
    containerPadding: gridConfig.CONTAINER_PADDING,
  }
}

export function getResponsiveGridContainerWidth(
  scalingConfig: ScalingConfig,
): number {
  if (typeof window === "undefined") {
    return scalingConfig.BASE_VIEWPORT_WIDTH
  }

  const viewportWidth = document.documentElement.clientWidth
  // At and below the breakpoint the sidebar is an overlay, not a column, so it
  // takes none of the grid's width.
  const sidebarWidth =
    viewportWidth <= SIDEBAR_COLLAPSE_BREAKPOINT ? 0 : EXPANDED_SIDEBAR_WIDTH
  const availableWidth =
    viewportWidth -
    sidebarWidth -
    getCoviDockWidth() -
    GRID_WRAPPER_HORIZONTAL_PADDING

  return Math.min(
    Math.max(availableWidth, scalingConfig.MIN_CONTAINER_WIDTH),
    scalingConfig.MAX_CONTAINER_WIDTH,
  )
}

function getCoviDockWidth(): number {
  const rawDockWidth = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(COVI_DOCK_WIDTH_CSS_VAR)
  const dockWidth = Number.parseFloat(rawDockWidth)

  return Number.isFinite(dockWidth) && dockWidth > 0 ? dockWidth : 0
}
